import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

let inMemoryToken = null;

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  // const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  // Configure axios defaults
  useEffect(() => {
    const initAuth = async () => {
      // try {
        // const response = await axios.get(
        //   `${process.env.REACT_APP_API_URL}/auth/me`,
        //   {
        //     headers: { 'Content-Type': 'application/json' },
        //     withCredentials: true
        //   }
        // );

      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const accessToken = params.get("access_token");

      if (accessToken) {
        inMemoryToken = accessToken;
        const payload = decodeJwt(accessToken);        

        if (payload && payload["SAMLUserData"]) {
          const samlData = payload["SAMLUserData"]
          setUser(samlData.email ? samlData.email[0] : null);
          setLocations(samlData.group || []);
        }

        window.history.replaceState({}, document.title, window.location.pathname);

        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/auth/me`,
            {
              headers: { Authorization: `Bearer ${inMemoryToken}` }
            }
          );

          if (response.data && response.data.SAMLUserData) {
            setUser(response.data.SAMLUserData.email[0]);
            setLocations(response.data.SAMLUserData.group);
          }

          // Check if the user is a super admin
          const searchString = 'HRQuery-Super-Admin'
          const hasSuperAdminGroup = response.data.SAMLUserData.group.some(item => item.toLowerCase() === searchString.toLowerCase());
          if (hasSuperAdminGroup === true) {
            setUserRole("super_admin_user_role");
          } else if (response.data.SAMLUserData.group.length > 0) {
            setUserRole("location_admin_user_role");
          }
        } catch (err) {
          setUser(null);
          setLocations([]);
        }
      }

      setLoading(false);
      // } catch {
      //   setUser(null);
      // } finally {
      //   setLoading(false);
      // }
    };

    const interceptor = axios.interceptors.request.use((config) => {
      if (inMemoryToken) {
        config.headers.Authorization = `Bearer ${inMemoryToken}`;
      }
      return config;
    }, []);

    initAuth();

    return () => {
      axios.interceptors.request.eject(interceptor);
    };
  }, []);

  const login = async () => {
    try {
      window.location.href = `${process.env.REACT_APP_API_URL}/sso/login`
    } catch (err) {
      console.log(err);
    }
  };

  const isUserAuthenticated = !!user;

  const logout = async () => {
    // await axios.post(
    //   `${process.env.REACT_APP_API_URL}/auth/logout`,
    //   null,
    //   {
    //     withCredentials: true
    //   }
    // );
    // setIsUserAuthenticated(false);
    inMemoryToken = null;
    setUser(null);
    setUserRole(null);
    setLocations([]);
    window.location.href = '/';
  };

  const value = {
    user,
    userRole,
    locations,
    isAuthenticated: isUserAuthenticated,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

function decodeJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    return payload;
  } catch (e) {
    console.error("Failed to decode JWT", e);
    return null;
  }
}